import './common/passiveSupported';

// turn on the following for polyfill, but increases size tremendously
//import 'core-js/stable';
//import 'regenerator-runtime/runtime';

import docReady from './common/docReady';
import { scanLoad, responseLoad } from './loader/promisesLoad';
import DynamicScriptLoad from './loader/DynamicScriptLoad';
import CMSUser from './loader/CMSUser';
import CMSWindow from './loader/CMSWindow';

import WindowWatcher from './loader/WindowWatcher';
import html from './common/basicTemplating';

// instantiate/init
const dynamicLoader = new DynamicScriptLoad;

// This is what we'll run when the DOM is ready
var initTasksLoad = function () {

  let cmsView = new CMSWindow;
  let currentUser = new CMSUser;
  Promise.resolve()
    .then(function () {
      return currentUser.initUser();
    })
    .then(function () {
      if (currentUser.checkAccessibility() && cmsView.editMode) {
        window.windowEvents = new WindowWatcher;
        dynamicLoader.load(currentUser.filePrefix());
        //TODO: cleanup following
        let copeScanDiv = document.createElement('div');
        copeScanDiv.id = 'cope-scan-ui';
        copeScanDiv.innerHTML = html`<ul id='cope-categories'></ul>`;
        document.querySelector('html').insertBefore(copeScanDiv, document.querySelector('body'));
        window.$categoriesList = $('#cope-categories');

        scanLoad()
          .then(() => responseLoad())
          .then(() => import('./frontend'))
          .then((loadedModule) => { loadedModule.frontEnd(); }, error => {
            console.error('failed to load library, fatal error: ' + error);
          });
      }
    });
};

// Call our DOM ready with the above function
docReady(initTasksLoad);